export default __webpack_public_path__ + "static/media/alert.bc95a198.svg";